// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"584":"a212fdfe","905":"b25853f3"}[chunkId] + ".chunk.css";
};